export interface Trip {
  email: string;
  journeys: Journey[];
  passengers: Passengers[];
  recLoc: string;
}

export interface ShortTrip {
  recLoc: string;
  lastName: string;
  dates: string[];
}

export interface OutboundJourney {
  departure: string;
  arrival: string;
  scheduledDateTime: string;
  scheduledDateTimeUnix: number;
  passengerAmount: number;
  bookingRef: string;
  mmbLink: string;
}

export interface Journey {
  flights: Flight[];
  journeyId: string;
  passengerAmount?: number;
  recLoc?: string;
}

export interface Passengers {
  email: string;
  firstName: string;
  frequentFlyerNumber: string;
  lastName: string;
  passengerFlightInfos: PassengerFlightInfo[];
  passengerNum: string;
  phoneNumber: string;
  plusLevel: string;
}

export interface Flight {
  arrival: FlightDetail;
  boarding: {
    gateStatus: string;
  };
  bookingClass: string;
  checkin: {
    checkinCloseDateTime: string;
    checkinOpenDateTime: string;
    checkinOptions: string[];
    checkinUrl: string;
    externalCheckin: boolean;
  };
  departure: FlightDetail;
  duration?: string;
  equipment?: string;
  flightNumber: string;
  marketingAirline: string;
  status: string;
  travelClass: string;
  uniqueId: string;
}

interface FlightDetail {
  airport: string;
  airportName: string;
  date: string;
  estimatedDateTime: string;
  municipality: string;
  scheduledDateTime: string;
  terminal: string;
}

interface PassengerFlightInfo {
  carryOnAllowance?: {
    finnairPersonalItems: string;
    maxTotalKg: string;
    pieces: string;
  };
  checkinStatus: string;
  flightUniqueId: string;
  freeAllowance?: {
    maxItemKg: string;
    pieces: string;
    sportsEquipment: boolean;
  };
  ticketNumber: string;
}

export enum AddFrequentFlyerError {
  PASSENGER_NOT_FOUND = 'passenger_not_found',
  BOOKING_NOT_FOUND = 'booking_not_found',
  ALREADY_EXISTS = 'other_ff_already_exists',
  GROUP_BOOKING = 'group_booking',
}

export interface AddFrequentFlyerResponse {
  status: {
    code: number;
    status: string;
    message: string;
  };
  error?: {
    status: {
      message: AddFrequentFlyerError;
    };
  };
}
